// ----------------------
// ENTITIES
// ----------------------
export const CLEAR_ENTITIES = 'CLEAR_ENTITIES';
export const CLEAR_ENTITY = 'CLEAR_ENTITY';
export const RECEIVE_ENTITIES = 'RECEIVE_ENTITIES';
export const RECEIVE_ENTITY = 'RECEIVE_ENTITY';

// ----------------------
// GENERAL
// ----------------------
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SET_DEBUG = 'SET_DEBUG';
export const SET_ERROR = 'SET_ERROR';
export const TOGGLE_RETHROW = 'TOGGLE_RETHROW';

// ----------------------
// FORMS
// ----------------------
export const UPDATE_INPUT = 'UPDATE_INPUT';
